/* eslint-disable no-debugger */
require("es6-promise").polyfill();
import axios from "axios";
import Session from "@/classes/Session";
import { apiUrl } from "@/config/config";

// Abstract class, meant to be extended, no instancieated
class Charts {
  constructor(version = "v2") {
    let jwt = Session.getJwtCookie();

    this.http = axios.create({
      baseURL: apiUrl + version + "/",
      headers: {
        "Content-Type": "application/json"
      }
    });

    if (jwt === undefined) {
      Session.logout();
      jwt = "";
    } else {
      this.set_jwt(jwt);
    }

    this.page_length = 25;
  }

  set_jwt(jwt_token) {
    this.http.defaults.headers.common["Authorization"] = "Bearer " + jwt_token;
  }

  async postQuery(params) {
    try {
      const result = await this.http.post("/statistixx", { params });
      return result.data;
    } catch (err) {
      throw err;
    }
  }
}

export default Charts;



// WEBPACK FOOTER //
// ./src/api/Charts.js